import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Advt } from './components/Advt/Advt';
import Winners from './components/Winner/Winners';

import { useGetParams } from './hooks/useGetParams';
import { useBroadcast } from './hooks/useBroadcast';

import posterDefault from './assets/images/poster.png';
import bgDefaultVideo from './assets/video/bgVideo.mp4';

import logo from './assets/images/logo.png';

import { motion, AnimatePresence } from 'framer-motion';
import Message from './components/Message/Message';

function App() {
  const { isVisible, currentState, winnerMesssages, currentMessage } =
    useBroadcast();
  const { bgVideo, bgPoster, title, winnerFontSize, titleFontSize } =
    useGetParams();

  return (
    <div className="app-wrapper">
      <SwitchTransition>
        <CSSTransition
          key={currentState}
          addEndListener={(node, done) =>
            node.addEventListener('transitionend', done, false)
          }
          classNames="fade-scale">
          <div style={{ height: '100%', position: 'relative', zIndex: '11' }}>
            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <div
                className="advtTitle"
                style={{ fontSize: `${titleFontSize}rem` }}>
                {title}
              </div>
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <div className="advtWrapper">
                <Advt />
              </div>
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <>
                {currentMessage && (
                  <AnimatePresence mode="wait">
                    <motion.div
                      initial={{
                        scale: 0,
                        x: currentMessage.animate.initialX,
                        y: currentMessage.animate.initialY,
                      }}
                      animate={{
                        opacity: 1,
                        scale: 1,
                        x: 0,
                        y: 0,
                        transition: { ease: 'easeIn', duration: 1.47 },
                      }}
                      exit={{
                        opacity: 0,
                        scale: 0,
                        x: currentMessage.animate.exitX,
                        y: currentMessage.animate.exitY,
                        transition: { ease: 'easeOut', duration: 1 },
                      }}
                      key={currentMessage.id}
                      style={{
                        position: 'relative',
                        zIndex: '11',
                        paddingRight: '50rem',
                      }}>
                      <Message
                        message={currentMessage.message}
                        isVertical={currentMessage.isVertical}
                      />
                    </motion.div>
                  </AnimatePresence>
                )}
              </>
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S1'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <img src={logo} alt="logo" className="logo" />
            </CSSTransition>

            <CSSTransition
              in={isVisible && currentState === 'S2'}
              timeout={500}
              classNames="fade-scale"
              unmountOnExit>
              <Winners
                winnerMessages={winnerMesssages}
                winnerFontSize={winnerFontSize}
              />
            </CSSTransition>
          </div>
        </CSSTransition>
      </SwitchTransition>

      {bgVideo && (
        <motion.video
          key="bgMain"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.5,
          }}
          autoPlay="autoplay"
          muted="muted"
          loop
          id="bgVideo"
          poster={bgVideo === '1' ? posterDefault : bgPoster}>
          <source
            src={bgVideo === '1' ? bgDefaultVideo : bgVideo}
            type="video/mp4"></source>
        </motion.video>
      )}

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
